import { ref, Ref } from "vue";
import { Is } from "cerceis-lib";

// Default as jpn

export type Languages = "jpn" | "eng";
export const languages: Languages[] = ["jpn", "eng"];
export const currentLanguage: Ref<Languages> = ref("jpn");
export const l: Ref<any> = ref({})

export const loadLanguageSet = (language: Languages = currentLanguage.value): void => {
    if(
        language !== "jpn" &&
        language !== "eng"
    ) return;
    currentLanguage.value = language;
    const loadedLang = require(`@/assets/lang/${language}.json`);
    if(Is.emptyObject(loadedLang)) return;
    l.value = loadedLang;
}